/* eslint-disable no-extra-boolean-cast */
/* eslint-disable jsx-quotes */
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import routes from '../../utils/routes';
import DataTable from '../data-table/data-table';
import Modal from '../modal/modal';
import './courses.css';
import {
    createCourse,
    deleteCourse,
    fetchCourses,
    fetchTypesTests,
    asyncSelectTestCreateCoruse
} from './courses.actions';
import ConfirmationModal from '../confirmation-modal/confirmation-modal';
import Loader from '../loader-component/loader';
import SelectTest from '../SelectTest';

class Courses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            courseId: '',
            courseName: '',
            showFilters: false,
            showAddModal: false,
        };
        this.clearState = this.clearState.bind(this);
    }

    componentDidMount() {
        this.props.fetchCourses();
        this.props.fetchTypesTests();
    }

    clearState() {
        this.setState({ courseId: '', showFilters: false, courseName: '' });
    }

    returnFilterModal() {
        const { courseId, courseName, showFilters } = this.state;
        return (
            <Modal show={showFilters} onClose={this.clearState}>
                <div className="filter-modal">
                    <div className="modal-header">
                        <span>Filtros</span>
                        <i
                            className="fa fa-times"
                            onClick={this.clearState}
                            title="Fechar"
                        />
                    </div>
                    <div className="filter-input-group">
                        <label>Sigla</label>
                        <input
                            id="sigla"
                            value={courseId}
                            onChange={({ target }) =>
                                this.setState({ courseId: target.value })
                            }
                        />
                    </div>

                    <div className="filter-input-group">
                        <label>Nome</label>
                        <input
                            id="name"
                            value={courseName}
                            onChange={({ target }) =>
                                this.setState({ courseName: target.value })
                            }
                        />
                    </div>
                    <div className="modal-footer">
                        <button
                            className="cancel-btn"
                            onClick={this.clearState}
                        >
                            Limpar Filtros
                        </button>
                        <button
                            className="save-btn"
                            onClick={() =>
                                this.setState({ showFilters: false })
                            }
                        >
                            Ok
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }

    render() {
        const { courses, loading, typeTests, tests } = this.props;
        return (
            <div className="courses-container courses">
                <Loader
                    show={loading ? true : false}
                    message={'Carregando, por favor aguarde...'}
                />
                <div className="new-entity-btn">
                    <button
                        className="add-course-btn"
                        onClick={() => this.setState({ showAddModal: true })}
                        title="Novo Curso"
                    >
                        <i className="fa fa-plus" />
                    </button>
                </div>
                <DataTable
                    className="courses-table"
                    data={courses}
                    columns={COLUMNS}
                    exportName={`cursos-${moment().toISOString()}.csv`}
                    searchFunction={() =>
                        this.setState({ showFilters: !this.state.showFilters })
                    }
                />
                {this.returnFilterModal()}
                {this.state.showAddModal && (
                    <NewCourseModal
                        courses={courses}
                        typeTests={typeTests}
                        tests={tests}
                        onClose={() => this.setState({ showAddModal: false })}
                        onSave={course => this.props.createCourse(course)}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = ({ courses }) => ({
    courses: courses.data,
    loading: courses.loading,
    typeTests: courses.typeTests,
    tests: courses.tests,
    duplicateTestCreateCourse: courses.duplicateTestCreateCourse
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCourses,
            createCourse,
            fetchTypesTests,
            asyncSelectTestCreateCoruse
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(Courses);

class _NewCourseModal extends React.Component {
    state = {
        courseId: '',
        courseName: '',
        willCopy: false,
        selectedCourseId: 'Selecione seu curso',
        tests: null,
        typeTests: [],
        typeTestsValues: {},
    };

    componentDidMount() {
        const { tests, typeTests } = this.props;

        const toSetTypeTestsValues = this.setTypeTestsToValues(typeTests);

        this.setState({
            tests,
            typeTests,
            typeTestsValues: toSetTypeTestsValues,
        });
    }

    componentDidUpdate(prevProps) {
        const { typeTests, tests, duplicateTestCreateCourse } = this.props;
        const { typeTestsValues: { MASTER, FORMACAO, UNIFICADO } } = this.state;
        if(prevProps.duplicateTestCreateCourse !== duplicateTestCreateCourse){
            this.setState({ ...this.state, typeTestsValues: { 
                FORMACAO: duplicateTestCreateCourse.FORMACAO ? duplicateTestCreateCourse.FORMACAO : FORMACAO, 
                UNIFICADO: duplicateTestCreateCourse.UNIFICADO ? duplicateTestCreateCourse.UNIFICADO : UNIFICADO, 
                MASTER: duplicateTestCreateCourse.MASTER ? duplicateTestCreateCourse.MASTER : MASTER } })
        }

        if (typeTests !== prevProps.typeTests) {
            const toSetTypeTestsValues = this.setTypeTestsToValues(typeTests);

            this.setState({
                typeTests,
                typeTestsValues: toSetTypeTestsValues,
            });
        }

        if (tests !== prevProps.tests) {
            this.setState({
                tests,
            });
        }
    }

    setTypeTestsToValues(typeTests) {
        const { typeTestsValues } = this.state;
        const auxToSetTypeTestsValues = {};
        typeTests.map(typeTest => {
            Object.assign(auxToSetTypeTestsValues, {
                [typeTest.id]: typeTestsValues[typeTest.id] || null,
            });
        });
        const toSetTypeTestsValues = auxToSetTypeTestsValues;

        return toSetTypeTestsValues;
    }

    handleChangeSelectTest(valueSelect, testId) {
        const { typeTestsValues } = this.state;
        const auxValuesTest = typeTestsValues;

        this.setState({
            // eslint-disable-next-line comma-dangle
            typeTestsValues: {
                ...auxValuesTest,
                [testId]: !!valueSelect ? valueSelect : null,
            },
        });
    }

    handleChange = ({ target }) => {
        const value =
            target.name === 'courseId'
                ? target.value.replace(/[^\w-]*/g, '')
                : target.value;
        this.setState({ [target.name]: value });
    };

    handleSubmit = e => {
        e.preventDefault();
        const {
            courseId,
            courseName,
            selectedCourseId,
            typeTestsValues,
        } = this.state;
        if (this.state.willCopy) {
            const submitCourse = this.props.courses.find(
                c => c.courseId === selectedCourseId,
            );
            this.props.onSave({
                ...submitCourse,
                courseId,
                courseName,
                typeTestsValues,
                submitCourse
            });
        } else {
            this.props.onSave({ courseId, courseName, typeTestsValues });
        }

        this.props.onClose();
    };

    handleCancel = e => {
        e.preventDefault();
        this.props.onClose();
    };

    render() {
        const {
            courseId,
            courseName,
            typeTests,
            tests,
            typeTestsValues,
        } = this.state;
        const { courses, ...props } = this.props;
        return (
            <Modal show={true} {...props}>
                <div className="new-course-modal">
                    <div className="modal-header">
                        <span>Novo Curso</span>
                        <i
                            className="fa fa-times"
                            onClick={this.props.onClose}
                            title="Fechar"
                        />
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <div className="new-course-modal-fields">
                            <div className="inline-form-row">
                                <label>Sigla:</label>
                                <input
                                    name="courseId"
                                    value={courseId}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div className="inline-form-row">
                                <label>Nome:</label>
                                <input
                                    name="courseName"
                                    value={courseName}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div className="inline-form-row">
                                <label>Duplicar curso?</label>
                                <select
                                    onChange={({ target }) =>
                                        this.setState({
                                            [target.name]: target.value,
                                        })
                                    }
                                    name="willCopy"
                                    value={this.state.willCopy}
                                >
                                    <option value="">Não</option>
                                    <option value="true">Sim</option>
                                </select>
                            </div>
                            {typeTests &&
                                typeTests.map((typeTest, index) => (
                                    <SelectTest
                                        key={index}
                                        name={typeTest.label}
                                        typeTest={typeTest}
                                        tests={tests}
                                        onChange={this.handleChangeSelectTest.bind(
                                            this,
                                        )}
                                        value={
                                            typeTestsValues[typeTest.id] || ''
                                        }
                                    />
                                ))}
                            {this.state.willCopy && (
                                <div className="inline-form-row">
                                    <label>Curso:</label>
                                    <select
                                        onChange={({ target }) =>{
                                            this.setState({
                                                [target.name]: target.value,
                                            })
                                            if(target.value !== 'Selecione seu curso') this.props.asyncSelectTestCreateCoruse(target.value);
                                        }}
                                        name="selectedCourseId"
                                        value={
                                            this.state.selectedCourseId || ''
                                        }
                                    >
                                        {[{courseName: 'Selecione seu curso', courseId: 'Selecione seu curso'}, ...courses].map(c => (
                                            <option
                                                key={c.courseId}
                                                value={c.courseId}
                                            >
                                                {c.courseName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                        </div>
                        <div className="new-course-modal-btns">
                            <button onClick={this.handleCancel}>
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                disabled={!courseId || !courseName}
                            >
                                Adicionar
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        );
    }

}

const NewCourseModal = connect(mapStateToProps, mapDispatchToProps)(_NewCourseModal);

class ActionsGroup extends React.Component {
    state = {
        askConfirmation: false,
    };

    render() {
        const { row: course } = this.props;

        return (
            <div className="actions-row">
                <Link to={routes.COURSE_RESOURCES(course.courseId)}>
                    <button title="editar">
                        <i className="fa fa-pencil" />
                    </button>
                </Link>
                <button
                    title="Remover"
                    onClick={() => this.setState({ askConfirmation: true })}
                >
                    <i className="fa fa-trash" />
                </button>
                {this.state.askConfirmation && (
                    <ConfirmationModal
                        show={true}
                        onClose={() =>
                            this.setState({ askConfirmation: false })
                        }
                        onConfirm={() =>
                            this.props.deleteCourse(course.courseId)
                        }
                    />
                )}
            </div>
        );
    }
}

const ActionsCell = connect(null, dispatch =>
    bindActionCreators({ deleteCourse }, dispatch),
)(ActionsGroup);

const COLUMNS = [
    { Header: 'Sigla', searchable: true, accessor: 'courseId' },
    { Header: 'Nome', searchable: true, accessor: 'courseName' },
    {
        Header: 'Ações',
        exportable: false,
        Cell: props => <ActionsCell {...props} />,
        sortable: false,
    },
];



// WEBPACK FOOTER //
// ./src/components/courses/courses.js